import { render, staticRenderFns } from "./AiCompaniesAdd.vue?vue&type=template&id=49d4ab64&"
import script from "./AiCompaniesAdd.vue?vue&type=script&lang=js&"
export * from "./AiCompaniesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports